
    <div class="nav">
      <div class="nav-top">
        <img
          style="margi-left: 20px;max-height: 30px;float: left;margin-left: 30px;margin-top: 1px;"
          alt="MyLion Logo"
          src="/assets/images/transparent_logo.gif"
        />
        <!--     <a href translate="btnContactUs">Contact Us</a> -->
        <div class="lci-translation">
          <app-lci-tranlsation-header></app-lci-tranlsation-header>
        </div>
        <a
          href
          translate="btnSupport"
          [href]="zenDeskUrl"
          target="_blank"
          (click)="reloadZendeskUrl($event)"
          >Support</a
        >
        <a *ngIf="showMessage" [attr.href]="messageUrl" translate="lblMessages"
          >Messages</a
        >
        <span class="user-menu">
          <div class="user-image"><div [ngStyle]="getProfileImageStyle()"></div></div>
          <a href (click)="toggleMenu($event)">
            {{ getUserName() }} <mat-icon>expand_more</mat-icon>
          </a>
          <div class="triangle" *ngIf="menuToggled">
            <div class="inner-triangle"></div>
          </div>
          <div class="user-menu" *ngIf="menuToggled">
            <ul>
              <li>
                <a
                  href="https://lci-mylion-userprofile-app-dev.azurewebsites.net"
                  translate="btnMyProfile"
                  >My Profile</a
                >
              </li>
              <li>
                <a href (click)="navigateLogout($event)" translate="menuLogout"
                  >Logout</a
                >
              </li>
            </ul>
          </div>
        </span>
      </div>
    </div>
    <!--    <p>
      <a routerLink="/root/protected" href>Secure Area</a><span *ngIf="loggedIn"> | </span>
      <a href (click)="signout()" *ngIf="loggedIn">Sign Out</a>
    </p> -->
  